import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/** One tile's place on the grid, in Gridstack cell units rather than pixels. */
export interface LinkTilePlacement {
    readonly uid: string;
    readonly x: number;
    readonly y: number;
    readonly w: number;
    readonly h: number;
}

/**
 * The complete arrangement of a page after a save: every tile that exists once
 * the creates and deletes in the same bulk have run.
 */
export interface ReorderLinkTilePayload {
    readonly linkviewUid: string;
    readonly order: readonly LinkTilePlacement[];
}

/**
 * The LAST sub-command of a save, and the ordering is load-bearing: this
 * command's uid list can only resolve once the creates have been written and
 * the deletes are gone.
 *
 * Note what identifies it: `mainEntityUid` is the PAGE's uid, not a tile's,
 * because the command is about the page's arrangement rather than any one tile.
 * `mainEntityClass` stays `link-tile`, which is what the backend name resolves
 * against.
 */
export class ReorderLinkTileCommand extends AbstractCommand<ReorderLinkTilePayload> {

    public name = CommandName.REORDER_LINK_TILE;

    public tags: string[] = [`entity`, `update`, `link-tile`];

    constructor(payload: ReorderLinkTilePayload) {
        super('link-tile', payload.linkviewUid, payload);
    }
}
